import { Shader, GlProgram, Color } from 'pixi.js';

const VERT = `
in vec2 aPosition;
in vec2 aUV;

out vec2 vUV;

uniform mat3 uProjectionMatrix;
uniform mat3 uWorldTransformMatrix;
uniform mat3 uTransformMatrix;

void main(void)
{
    mat3 mvp = uProjectionMatrix * uWorldTransformMatrix * uTransformMatrix;
    gl_Position = vec4((mvp * vec3(aPosition, 1.0)).xy, 0.0, 1.0);

    vUV = aUV;
}`;

export const FRAGMENT = `#define M_PI 3.1415926535897932384626433832795

in vec2 vUV;
uniform vec4 uColor;
uniform sampler2D uTexture;

void main(void)
{
    vec2 pos = vUV;
    vec2 center = vec2(0.5, 0.5);
    vec2 delta = pos - center;

    float d = length(delta) * 3.;
    float a = 3. * atan(-delta.y, delta.x) / M_PI;

	vec2 rad = vec2(1.0-d, a);

	gl_FragColor = texture2D(uTexture, rad) * uColor;
}
`;

export class CircleShader extends Shader {
    constructor(texture) {
        super({
            glProgram: GlProgram.from({ vertex: VERT, fragment: FRAGMENT }),
            resources: {
                uTexture: texture.source,
                circleUniforms: {
                    uColor: { value: new Float32Array([1, 1, 1, 1]), type: 'vec4<f32>' },
                },
            },
        });
        this.texture = texture;
    }

    setTint(color, alpha = 1) {
        const [r, g, b] = new Color(color).toArray();
        this.resources.circleUniforms.uniforms.uColor = new Float32Array([r * alpha, g * alpha, b * alpha, alpha]);
    }
}

// kept as an alias for the pre-v8 name
export { CircleShader as CircleMaterial };
